import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserInfoState } from 'src/store/reducers/user-info.reducer';
import { inject } from '@angular/core';

export const guestGuard: CanActivateFn = () => {
    const store = inject<Store<{ userInfo: UserInfoState }>>(Store);
    const router = inject(Router);

    return store
        .select((state) => state.userInfo)
        .pipe(
            take(1),
            map((userInfo) => (userInfo ? router.createUrlTree(['/home']) : true))
        );
};
